import { render, staticRenderFns } from "./CardEmploymentPolicies.vue?vue&type=template&id=2a135d88&scoped=true&"
import script from "./CardEmploymentPolicies.vue?vue&type=script&lang=js&"
export * from "./CardEmploymentPolicies.vue?vue&type=script&lang=js&"
import style0 from "./CardEmploymentPolicies.vue?vue&type=style&index=0&id=2a135d88&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a135d88",
  null
  
)

export default component.exports